import { render, staticRenderFns } from "./NotificationStatusToggle.vue?vue&type=template&id=11f4aa44&scoped=true"
import script from "./NotificationStatusToggle.vue?vue&type=script&lang=js"
export * from "./NotificationStatusToggle.vue?vue&type=script&lang=js"
import style0 from "./NotificationStatusToggle.vue?vue&type=style&index=0&id=11f4aa44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f4aa44",
  null
  
)

export default component.exports